module.exports = __webpack_public_path__ + "assets/df09b194706975f51c444bdf7cd2515f.png";